import NavBar from "../../../../Navbar/Navbar";
import { useState } from "react";
import { updateStatusDocuments } from "../../../../../AdminAPI/UpdateStatusDocADM";
import Cookies from "js-cookie";
import "./AdmMassUpdate.css";
import { useTranslation } from "react-i18next";

const MassUpdate = () => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [docList, setDocList] = useState("");
  const [message, setMessage] = useState("");
  const token = Cookies.get("Token");
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!currentStatus || !newStatus || !docList) {
      setMessage(t("All fields are required."));
      return;
    }

    try {
      const formattedDocList = JSON.stringify(
        docList.split(",").map((id) => id.trim())
      );

      const result = await updateStatusDocuments(
        currentStatus,
        newStatus,
        formattedDocList,
        token
      );

      setMessage(t("Documents successfully updated !"));
    } catch (error) {
      setMessage(t("Erreur lors de la mise à jour des documents."));
      console.error(error);
    }
  };

  return (
    <>
      <div id="massupdate-page">
        <NavBar />

        {/* --- TITRE + TRAIT --- */}
        <div id="massupdate-title-container">
          <h1 id="massupdate-title">
            <i className="fas fa-edit"></i>
            {t("MassUpdate")}
          </h1>
          <div id="massupdate-title-line" />
        </div>

        {/* --- DIV GRIS DERRIERE LA CARD --- */}
        <div id="massupdate-bg">
          <div id="massupdate-card">
            <form id="massupdate-form" onSubmit={handleSubmit}>
              <label>{t("Current status :")}</label>
              <input
                type="text"
                value={currentStatus}
                onChange={(e) => setCurrentStatus(e.target.value)}
              />

              <label>{t("New status :")}</label>
              <input
                type="text"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
              />

              <label>{t("List doc id (comma separated) :")}</label>
              <textarea
                value={docList}
                onChange={(e) => setDocList(e.target.value)}
              />

              <button id="massupdate-submit-btn" type="submit">
                {t("To modify")}
              </button>

              {message && (
                <div
                  id="massupdate-message"
                  className={
                    message.includes("succès") ||
                    message.includes("successfully")
                      ? "success"
                      : "error"
                  }
                >
                  {message}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default MassUpdate;
